import { AppHistory } from "@faire/retailer/packages/core/services/AppHistory";

import Redirects from "../services/Redirects";

import { redirectRules } from "./redirectRules";

export const watchForRedirects = () => {
  new Redirects(redirectRules).listen(AppHistory.get().history);
};
